<template>
  <div>
    <project-one-rail-layout :base-properties="baseProperties" />
  </div>
</template>

<script>
import {mapMutations, mapActions} from 'vuex';
import ProjectOneRailLayout from '@/projectOne/components/rightRail/ProjectOneRailLayout';

export default {
  /*
    This generic view is a placeholder component for modules that haven't been implemented yet.
    A new module specific view should be created during that module's implementation.
    This generic view should be deleted once all modules are implemented.
  */
  components: {ProjectOneRailLayout},

  created() {
    const railConfig = {
      content: {},
    };

    this.clearRailDataStack();
    this.pushToRailDataStack(railConfig);

    this.$nextTick(() => {
      this.calculateApplicationHeight();
    });
  },

  methods: {
    ...mapMutations('projectOne', ['pushToRailDataStack', 'clearRailDataStack', 'calculateApplicationHeight']),
    ...mapActions('projectOne', ['proceedToNextStep']),
  },
};
</script>
